import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { requestCookieConsentReopen } from "../../utils/analytics-consent";
import styles from "./footer.module.scss";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.footer}>
      <div className={styles.licence}>{t("footer.copyright")}</div>

      <nav className={styles.legalLinks} aria-label={t("footer.legalNav", "Legal")}>
        <Link className={styles.policy} to="/datenschutz">
          {t("footer.privacy")}
        </Link>
        <Link className={styles.policy} to="/agb">
          {t("footer.terms")}
        </Link>
        <Link className={styles.policy} to="/impressum">
          {t("footer.impressum")}
        </Link>
        <button
          type="button"
          className={styles.cookieButton}
          onClick={requestCookieConsentReopen}
        >
          {t("cookieConsent.settingsLink", "Cookie settings")}
        </button>
      </nav>

      {/*
        The social icons linked to DMY's YouTube, Instagram and Facebook
        accounts — a visitor clicking them left this site for a different
        brand's channels — so the rebrand pass commented the row out.

        Checked against nicolas-smith.store on 2026-08-01 to point them at our
        own accounts instead: there are none to point at. The storefront footer
        has no social links at all; the two circled icons it shows there are
        decorative lucide glyphs (a globe and an award badge) with no href. A
        grep of its full JS bundle for instagram / facebook / youtube / tiktok /
        t.me / twitter / linkedin URLs and handles returned nothing, and the
        only contact anywhere on the site is mailto:info@nicolas-smith.store.

        So the row stays out rather than shipping three dead icons. Restore it
        when Nicolas Smith has accounts — the styles are untouched and still in
        footer.module.scss.

        <div className={styles.links}>
          <a className={styles.youtube} aria-label="YouTube" href="" target="_blank" rel="noopener noreferrer" />
          <a className={styles.instagram} aria-label="Instagram" href="" target="_blank" rel="noopener noreferrer" />
          <a className={styles.fb} aria-label="Facebook" href="" target="_blank" rel="noopener noreferrer" />
        </div>
      */}
    </div>
  );
};

export default Footer;
